import request from '@/utils/request';
import { PageResult } from '@/api/typing';

export async function create_product_company(params: Record<string, any>) {
  return request.post('/mjstock/create_product_company', params);
}

export async function update_product_company(params: Record<string, any>) {
  return request.post('/mjstock/update_product_company', params);
}

export async function delete_product_company(params: Record<string, any>) {
  return request.post('/mjstock/delete_product_company', params);
}

export async function recover_product_company(params: Record<string, any>) {
  return request.post('/mjstock/recover_product_company', params);
}

export async function query_product_company_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_company_list', params);
}

export async function query_product_in_cancel_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_in_cancel_record_list', params);
}

export async function create_product_in_cancel_record(params?: { [key: string]: any }) {
  return request.post('/mjstock/create_product_in_cancel_record', params);
}
export async function delete_product_in_cancel_record(params?: { [key: string]: any }) {
  return request.post('/mjstock/delete_product_in_cancel_record', params);
}

export async function remove_productinrecord(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstock/remove_productinrecord', params);
}

export async function get_product_in_record(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstock/get_product_in_record', params);
}

export async function create_productinrecord(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstock/create_productinrecord', params);
}

export async function update_productinrecord(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstock/update_productinrecord', params);
}

export async function query_product_in_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_in_record_list', params);
}

export async function query_product_in_record_1_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_in_record_1_list', params);
}

export async function query_product_in_record_2_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_in_record_2_list', params);
}

export async function query_product_in_record_3_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_in_record_3_list', params);
}

export async function query_product_in_record_4_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_in_record_4_list', params);
}

export async function create_product_out_cancel_record(params?: { [key: string]: any }) {
  return request.post('/mjstock/create_product_out_cancel_record', params);
}

export async function delete_product_out_cancel_record(params?: { [key: string]: any }) {
  return request.post('/mjstock/delete_product_out_cancel_record', params);
}

export async function query_product_out_cancel_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_out_cancel_record_list', params);
}

export async function create_product_out_record(params?: { [key: string]: any }) {
  return request.post('/mjstock/create_product_out_record', params);
}

export async function delete_product_out_record(params?: { [key: string]: any }) {
  return request.post('/mjstock/delete_product_out_record', params);
}

export async function query_product_out_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_out_record_list', params);
}

export async function query_product_out_record_1_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_out_record_1_list', params);
}

export async function query_product_out_record_2_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_out_record_2_list', params);
}

export async function query_product_out_record_3_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_out_record_3_list', params);
}

export async function query_product_out_record_4_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_out_record_4_list', params);
}

export async function query_product_out_record_5_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_out_record_5_list', params);
}

export async function query_product_out_record_6_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_product_out_record_6_list', params);
}

export async function get_s_product(params: Record<string, any>) {
  return request.post('/mjstock/get_s_product', params);
}
export async function create_s_product(params: Record<string, any>) {
  return request.post('/mjstock/create_s_product', params);
}

export async function update_s_product(params: Record<string, any>) {
  return request.post('/mjstock/update_s_product', params);
}

export async function delete_s_product(params: Record<string, any>) {
  return request.post('/mjstock/delete_s_product', params);
}

export async function recover_s_product(params: Record<string, any>) {
  return request.post('/mjstock/recover_s_product', params);
}

export async function query_s_product_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstock/query_s_product_list', params);
}

export async function create_supply_company(params: Record<string, any>) {
  return request.post('/mjstock/create_supply_company', params);
}

export async function update_supply_company(params: Record<string, any>) {
  return request.post('/mjstock/update_supply_company', params);
}

export async function delete_supply_company(params: Record<string, any>) {
  return request.post('/mjstock/delete_supply_company', params);
}

export async function recover_supply_company(params: Record<string, any>) {
  return request.post('/mjstock/recover_supply_company', params);
}
export async function confirm_product_out_cancel_record(params: Record<string, any>) {
  return request.post('/mjstock/confirm_product_out_cancel_record', params);
}

export async function get_product_in_record_by_out(params: Record<string, any>) {
  return request.post('/mjstock/get_product_in_record_by_out', params);
}

export async function query_supply_company_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_supply_company_list', params);
}

export async function create_s_product_type(params: Record<string, any>) {
  return request.post('/mjstock/create_s_product_type', params);
}

export async function update_s_product_type(params: Record<string, any>) {
  return request.post('/mjstock/update_s_product_type', params);
}

export async function delete_s_product_type(params: Record<string, any>) {
  return request.post('/mjstock/delete_s_product_type', params);
}

export async function recover_s_product_type(params: Record<string, any>) {
  return request.post('/mjstock/recover_s_product_type', params);
}

export async function query_s_product_type_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_s_product_type_list', params);
}

export async function query_operation_log_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstock/query_operation_log_list', params);
}
